import {
  AtlasBodyMain,
  CardComponent,
  TagMolecule
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { StackAtom } from 'components/atoms/Stack.atom'
import type { TransferData } from 'types/commons/model'

interface ShipmentCardProps {
  transferData: TransferData
  onClick?: () => void
}

export const ShipmentCardOrganism = (props: ShipmentCardProps) => {
  const { transferData, onClick } = props

  return (
    <CardComponent onClick={onClick}>
      <StackAtom $justify="space-between">
        <StackAtom $direction="column" $gap={4} style={{ minWidth: '125px' }}>
          <StackAtom $gap={4} $align="center">
            <AtlasBodyMain style={{ fontWeight: 700, wordBreak: 'break-all' }}>
              {transferData.docNum}
            </AtlasBodyMain>
          </StackAtom>

          <StackAtom $gap={4} $align="center">
            <TagMolecule
              shape="rounded"
              bgColor="#212121"
              icon={<Icon name="ic_location" color="white" size={24} />}
            />

            {/* TODO: take location from transferData */}
            <AtlasBodyMain>CANAL-1</AtlasBodyMain>
          </StackAtom>
        </StackAtom>

        <StackAtom $gap={8} $align="center">
          <TagMolecule text={transferData.warehouse} />
          <TagMolecule
            text={`${transferData.containersQty}`}
            icon={<Icon name="ic_pallet" size={18} color="white" />}
          />
          <TagMolecule
            text={`${transferData.totalSKUs}`}
            icon={<Icon name="ic_product" size={18} color="white" />}
          />
        </StackAtom>
      </StackAtom>
    </CardComponent>
  )
}
